/**
 * WEB-1723 — одна точка правды для «инертного макета» блоков портала.
 *
 * Вне провайдера портала (usePortalActions() === null) блоки портала рисуют
 * макет: элемент виден, но ничего не делает. Раньше инертность держалась
 * атрибутом `disabled`, и это ломало редактор: браузер по спецификации HTML
 * НЕ порождает событий мыши на выключенном элементе формы, поэтому клик не
 * всплывал до делегата выбора блока в EditorPreviewZone (он ищет ближайшего
 * предка с `data-block-id`). У кнопок отмены и возобновления выключенная
 * кнопка занимает всю площадь блока — попасть по нему было нечем, блок не
 * выделялся и его настройки нельзя было открыть кликом.
 *
 * Правило: на канвасе редактора инертность держится ОТСУТСТВИЕМ обработчика
 * (макетная ветка его и не вешает) плюс `aria-disabled` для читалок с экрана,
 * а не атрибутом `disabled`. Вне редактора — на публичной странице портала —
 * `disabled` остаётся ровно как был: живые воронки не трогаем.
 */
import { useEditorPreview } from '../EditorPreviewContext';

export interface InertPreviewProps {
  disabled: boolean;
  'aria-disabled': true;
}

export function useInertPreviewProps(): InertPreviewProps {
  const { isEditorPreview } = useEditorPreview();
  return { disabled: !isEditorPreview, 'aria-disabled': true };
}
